import {useEffect, useState} from "react";
import {Button, Col, Divider, Input, Modal, Row, Switch, Table} from "antd";
import i18next from "i18next";
import * as Setting from "../../conf/Setting";
import * as UserBackend from "../../services/UserBackend";
import moment from "moment";
import UserTransfer from "./UserTransfer";
import UserImport from "./UserImport";
import UserExportModal from "./UserExportModal";
import * as IconFont from "../common/IconFont";
import "../../assets/styles/user/UserListTable.less";

const {Search} = Input;

export const UserListTable = (props) => {
  const {account, nodeData} = props;
  const [pagination, setPagination] = useState({current: 1,
    pageSize: 10});
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [users, setUsers] = useState([]);
  const [memberCount, setMemberCount] = useState(0);
  const [isDirectUser, setIsDirectUser] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState(null);
  const [operateEnable, setOperateEnable] = useState(false);
  const [tranferModalVisible, setTranferModalVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [forbiddenModalVisible, setForbiddenModalVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [forbiddenUser, setForbiddenUser] = useState({});
  const [forbiddenChecked, setForbiddenChecked] = useState({});
  const [importVisible, setImportVisible] = useState(false);
  const [importType, setImportType] = useState("");
  const [userTransferConfirmLoading, setUserTransferConfirmLoading] = useState(false);
  const [userExportModalVisible, setUserExportModalVisible] = useState(false);
  const [userExportConfirmLoading] = useState(false);

  const newUser = (organId, departmentName) => {
    const randomName = Setting.getRandomName();
    const owner = organId;
    return {
      owner: owner,
      name: `user_${randomName}`,
      createdTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      updatedTime: moment().format("yyyy-MM-DD HH:mm:ss"),
      type: "normal-user",
      gender: "0",
      password: "123",
      passwordSalt: "",
      displayName: `新用户 - ${randomName}`,
      avatar: "",
      email: "",
      phone: "",
      address: [],
      idCard: "",
      affiliation: "Example Inc.",
      tag: "staff",
      region: "",
      isAdmin: Setting.isAdminOrganization(owner),
      isGlobalAdmin: false,
      IsForbidden: false,
      isDeleted: false,
      properties: {},
      signupApplication: "",
      orgOwner: Setting.Admin,
      department: departmentName,
      isActive: false, // 激活状态
      post: "0", // 岗位 （本科生辅导员1、本科生班主任2、部门秘书3、分管安全工作领导4、分管本科生教学领导5、未知0）
      studentStatus: "0", // 学籍状态（注册学籍1、休学2、保留学籍3、毕业4、退学5、未知0）
      employmentStatus: "0", // 任职状态（在职1、离职2、退休3、未知0）
      leaveDate: "", // 离职时间（时间格式为：2022-10-19）
    };
  };

  useEffect(() => {
    setUsers([]);
    setMemberCount(0);
    setSelectedRowKeys([]);
    setSearchText("");
    fetchMemberCount();
    setOperateEnable(false);
    fetchUsers({pagination: pagination, searchText: searchText, direct: isDirectUser, ...filters});
  }, [nodeData]);

  const fetchUsers = (params = {}) => {
    if (nodeData !== null && nodeData !== undefined) {
      let field = params.searchedColumn, value = params.searchText;
      if (params["isActive"] !== null && params["isActive"] !== undefined) {
        const filterValue = params["isActive"][0];
        if (filterValue === "0" || filterValue === "1") {
          field = "isActive";
          value = filterValue;
        }
      }
      const direct = params?.direct ? 1 : 0;
      const sortField = params.sortField, sortOrder = params.sortOrder;
      setLoading(true);
      if (nodeData?.level === 0 || nodeData?.isDept === false) {
        UserBackend.getOrganizationUsers(Setting.Admin, nodeData.uid, direct, params.pagination.current,
          params.pagination.pageSize, field, value, sortField, sortOrder)
          .then((res) => {
            setLoading(false);
            if (res.status === "ok") {
              setUsers(res.data);
              setPagination({
                ...params.pagination,
                total: res.data2,
              });
            }
          }).catch(error => {
            setLoading(false);
            Setting.showResponseMessage(error);
          });
      } else {
        UserBackend.getDepartmentUsers(nodeData.uid, direct, params.pagination.current,
          params.pagination.pageSize, field, value, sortField, sortOrder)
          .then((res) => {
            setLoading(false);
            if (res.status === "ok") {
              setUsers(res.data);
              setPagination({
                ...params.pagination,
                total: res.data2,
              });
            }
          }).catch(error => {
            setLoading(false);
            Setting.showResponseMessage(error);
          });
      }
    }
  };

  const onSearch = (value) => {
    setSearchText(value);
    fetchUsers({pagination: pagination, searchText: value, direct: isDirectUser});
  };

  const handleSwitchDirectUser = (checked) => {
    setIsDirectUser(checked);
    fetchUsers({pagination: pagination, searchText: searchText, direct: checked, ...filters});
  };

  const fetchMemberCount = () => {
    if (nodeData !== null && nodeData !== undefined) {
      if (nodeData?.level === 0 || nodeData?.isDept === false) {
        UserBackend.getOrganizationUserCount(nodeData.uid)
          .then(res => {
            if (res.status === "ok") {
              setMemberCount(res.data);
            }
          })
          .catch();
      } else {
        UserBackend.getDepartmentUserCount(nodeData.uid)
          .then(res => {
            if (res.status === "ok") {
              setMemberCount(res.data);
            }
          })
          .catch();
      }
    }
  };

  const handleAddUser = () => {
    if (nodeData?.level === 0 || nodeData?.isDept === false) {
      const user = newUser(nodeData.uid, nodeData.displayName);
      UserBackend.addOrganizationUser(user, nodeData.uid)
        .then((res) => {
          if (res.status === "ok") {
            // onAddUser(user);
            props.history.push({pathname: `/users/${user.owner}/${user.name}`, mode: "add"});
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    } else {
      const user = newUser(nodeData.organId, nodeData.displayName);
      UserBackend.addDepartmentUser(user, nodeData.uid)
        .then((res) => {
          if (res.status === "ok") {
            // onAddUser(user);
            props.history.push({pathname: `/users/${user.owner}/${user.name}`, mode: "add"});
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    }
  };

  const onUpdateDepartments = () => {
    setSelectedRowKeys([]);
    setOperateEnable(false);
    fetchMemberCount();
    fetchUsers({pagination: pagination, searchText: searchText, direct: isDirectUser, ...filters});
  };

  const handleDeleteUsers = () => {
    setConfirmLoading(true);
    UserBackend.deleteUsers(selectedRowKeys)
      .then(res => {
        setConfirmLoading(false);
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("user:User deleted successfully"));
          setModalVisible(false);
          setSelectedRowKeys([]);
          setOperateEnable(false);
          fetchMemberCount();
          fetchUsers({pagination: pagination, searchText: searchText, direct: isDirectUser, ...filters});
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        setConfirmLoading(false);
        Setting.showResponseMessage(error);
      });
  };

  const handleForbiddenUser = () => {
    setConfirmLoading(true);
    UserBackend.forbiddenUser(forbiddenUser.id, forbiddenChecked)
      .then(res => {
        setConfirmLoading(false);
        if (res.status === "ok") {
          setForbiddenModalVisible(false);
          setOperateEnable(false);
          fetchUsers({pagination: pagination, searchText: searchText, direct: isDirectUser, ...filters});
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        setConfirmLoading(false);
        Setting.showResponseMessage(error);
      });
  };

  const handleClickForbiddenSwitch = (user, checked) => {
    if (checked) {
      setForbiddenChecked(checked);
      setForbiddenUser(user);
      setForbiddenModalVisible(true);
    } else {
      UserBackend.forbiddenUser(user.id, checked)
        .then(res => {
          if (res.status === "ok") {
            setOperateEnable(false);
            fetchUsers({pagination: pagination, searchText: searchText, direct: isDirectUser, ...filters});
          } else {
            Setting.showResponseMessage(res.msg);
          }
        })
        .catch(error => {
          Setting.showResponseMessage(error);
        });
    }
  };

  const handleTableChange = (pagination, filter, sorter) => {
    setFilters(filter);
    fetchUsers({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filter,
      searchText: searchText,
      direct: isDirectUser,
    });
  };

  const handleOpenImportData = (type) => {
    setImportType(type);
    setImportVisible(true);
  };

  const handleOpenExportUser = () => {
    setUserExportModalVisible(true);
  };

  const onTransferUser = (transferedNodes) => {
    const userIds = selectedRowKeys;
    const organIds = transferedNodes.map(node => {
      return node.level === 0 ? node.uid : node.organId;
    });
    // 去重
    const organIdsRemoveDup = organIds.filter((item, index) => {
      return organIds.indexOf(item) === index;
    });
    // 不允许用户在多个组织
    if (organIdsRemoveDup.length > 1) {
      Setting.showMessage("error", i18next.t("user:User can't be assigned to different organizations"));
      return;
    }
    const oldOrganId = nodeData.level === 0 ? nodeData.uid : nodeData.organId;
    const newOrganId = organIdsRemoveDup[0] !== oldOrganId ? organIdsRemoveDup[0] : "";
    const transferDepts = transferedNodes.map(node => {
      return {
        deptId: node.uid, // 当前部门或组织的uid （必填）
        isDept: node.level === 0 ? false : true, // 是组织还是部门 0组织, 1部门 (必填)
        displayName: node.displayName,
      };
    });
    setUserTransferConfirmLoading(true);
    UserBackend.updateDepartments(userIds, transferDepts, newOrganId)
      .then(res => {
        setUserTransferConfirmLoading(false);
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully saved"));
          setTranferModalVisible(false);
          onUpdateDepartments();
        } else {
          Setting.showResponseMessage(res.msg);
        }
      })
      .catch(error => {
        setUserTransferConfirmLoading(false);
        Setting.showResponseMessage(error);
      });
  };

  const columns = [
    {
      title: i18next.t("general:Number"),
      dataIndex: "index",
      key: "index",
      width: (Setting.isMobile()) ? "60px" : "100px",
      fixed: "left",
      align: "center",
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: i18next.t("user:Name"),
      dataIndex: "name",
      key: "name",
      width: (Setting.isMobile()) ? "80px" : "160px",
      fixed: "left",
      ellipsis: true,
      render: (text, record, index) => {
        return !Setting.isAdminUser(account) || Setting.isAdminOrganization(nodeData?.uid) && !Setting.isSuperAdminUser(account) ? text :
          <a onClick={() => {
            // onEditUser(record);
            props.history.push({pathname: `/users/${record.owner}/${record.name}`, mode: "edit"});
          }}>{record.name}</a>;
      },
    },
    {
      title: i18next.t("user:Display name"),
      dataIndex: "displayName",
      key: "displayName",
      width: "140px",
      ellipsis: true,
    },
    {
      title: i18next.t("general:Phone"),
      dataIndex: "phone",
      key: "phone",
      width: "140px",
    },
    {
      title: i18next.t("general:Email"),
      dataIndex: "email",
      key: "email",
      width: "180px",
      ellipsis: true,
    },
    {
      title: i18next.t("general:Avatar"),
      dataIndex: "avatar",
      key: "avatar",
      width: "140px",
      align: "center",
      render: (text, record, index) => {
        return (
          // <a target="_blank" rel="noreferrer" href={text}>
          //   <img src={text === "" ? require("../assets/images/default_avatar.png") : text} alt={""} width={50} height={50} />
          // </a>
          <img src={text === "" ? require("../../assets/images/default_avatar.png") : text} alt={""} width={50} height={50} />
        );
      },
    },
    {
      title: i18next.t("user:Departments"),
      dataIndex: "department",
      key: "department",
      width: "180px",
      ellipsis: true,
    },
    {
      title: i18next.t("user:Activated"),
      dataIndex: "isActive",
      key: "isActive",
      width: "180px",
      filters: [
        {
          text: i18next.t("user:All State"),
          value: "2",
        },
        {
          text: i18next.t("user:Activated NO"),
          value: "0",
        },
        {
          text: i18next.t("user:Activated YES"),
          value: "1",
        },
      ],
      filterMultiple: false,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      // onFilter: (value, record) => {
      //   // eslint-disable-next-line no-console
      //   console.log(value);
      // },
      render: (text, record, index) => {
        return record.isActive ? <div style={{width: 59, height: 24, background: "rgba(45, 120, 213, 0.20)",
          color: "#2D78D5", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 2}}>{i18next.t("user:Activated YES")}</div>
          : <div style={{width: 59, height: 24, background: "rgba(255, 163, 65, 0.20)",
            color: "#FFA341", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 2}}>{i18next.t("user:Activated NO")}</div>;
      },
    },
    {
      title: i18next.t("user:Last signin time"),
      dataIndex: "lastSigninTime",
      key: "lastSigninTime",
      width: "180px",
      sorter: true,
      render: (text, record, index) => {
        return Setting.getFormattedDate(text);
      },
    },
    {
      title: i18next.t("user:Is forbidden"),
      dataIndex: "isForbidden",
      key: "isForbidden",
      width: "100px",
      fixed: (Setting.isMobile()) ? "false" : "right",
      align: "center",
      render: (text, record, index) => {
        return (
          <Switch
            checkedChildren={i18next.t("general:Yes")}
            unCheckedChildren={i18next.t("general:No")}
            disabled={(Setting.isSuperAdminUser(record) || !Setting.isAdminUser(account) || Setting.isAdminOrganization(nodeData?.uid) && !Setting.isSuperAdminUser(account))
              ? true : false}
            checked={text} onClick={(checked) => handleClickForbiddenSwitch(record, checked)} />
        );
      },
    },
    {
      title: i18next.t("general:Action"),
      dataIndex: "",
      key: "op",
      width: "100px",
      fixed: (Setting.isMobile()) ? "false" : "right",
      align: "center",
      render: (text, record, index) => {
        return (
          <div>
            <Button type="link"
              disabled={!Setting.isAdminUser(account) || Setting.isAdminOrganization(nodeData?.uid) && !Setting.isSuperAdminUser(account)}
              onClick={() => {
                // onEditUser(record);
                props.history.push({pathname: `/users/${record.owner}/${record.name}`, mode: "edit"});
              }}>{i18next.t("general:Edit")}</Button>
          </div>
        );
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setOperateEnable(newSelectedRowKeys.length > 0 ? true : false);
    },
    getCheckboxProps: (record) => {
      // admin的账户不可删除
      if (record.name === Setting.Admin) {
        return {disabled: true};
      }
      // 管理员不可删除自己
      if (Setting.isSuperAdminUser(record.owner)) {
        return {disabled: true};
      }

      return null;
    },
  };

  const paginationProps = {
    total: pagination.total,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: () => i18next.t("general:{total} in total").replace("{total}", pagination.total),
  };

  const opButtonStyle = {
    minWidth: "70px",
    height: "32px",
    marginRight: "12px",
    borderRadius: "2px",
  };

  return <div>
    <Table
      className="user-table"
      scroll={{x: "100%", y: "calc(100vh - 319px)"}}
      columns={columns}
      dataSource={users}
      rowKey="id"
      size="middle"
      pagination={paginationProps}
      rowSelection={Setting.isAdminOrganization(nodeData?.uid) && !Setting.isSuperAdminUser(account) ? null : rowSelection}
      tableLayout="fixed"
      title={() => (
        <>
          <Row justify="space-between" style={{marginBottom: "8px"}}>
            <Row style={{marginBottom: "0px"}} align="middle">
              <span style={{fontSize: "16px", fontWeight: 600, color: "#333"}}>{nodeData?.displayName}</span>
              <IconFont.MemberIcon style={{marginLeft: "20px", marginRight: "8px", color: "#666", fontSize: 16}} />
              <span style={{lineHeight: "15px", color: "#666"}}>({i18next.t("user:{count} Members").replace("{count}", memberCount)})</span>
            </Row>
            <Col>
              <Search value={searchText}
                onChange={(e) => {setSearchText(e.target.value);}}
                placeholder={i18next.t("user:Search placeholder")}
                onSearch={onSearch}
                allowClear={true}
                style={{width: 250}} />
            </Col>
          </Row>
          <Divider style={{marginTop: "0", marginBottom: "10px"}} />
          <Row align="bottom" justify="space-between" style={{marginBottom: 16}}>
            {
              Setting.isAdminOrganization(nodeData?.uid) && !Setting.isSuperAdminUser(account) ? null :
                <div>
                  <Button style={opButtonStyle} type="primary" size="small"onClick={handleAddUser} >{i18next.t("user:Create User")}</Button>
                  {Setting.isAdminOrganization(nodeData?.uid) ? null :
                    <>
                      <Button style={opButtonStyle} type="primary"
                        ghost size="small" onClick={() => handleOpenImportData("department")}>{i18next.t("import:Import Department")}</Button>
                      <Button style={opButtonStyle} type="primary"
                        ghost size="small" onClick={() => handleOpenImportData("user")}>{i18next.t("import:Import User")}</Button>
                      {
                        nodeData?.level === 0 ?
                          <Button style={opButtonStyle} type="primary"
                            ghost size="small" onClick={() => handleOpenExportUser()}>{i18next.t("user:Export user")}</Button>
                          :
                          null
                      }
                      <Button disabled={!operateEnable} style={opButtonStyle} type="primary" size="small"
                        ghost onClick={() => setTranferModalVisible(true)}>{i18next.t("user:Transfer departments")}</Button>
                    </>
                  }
                  <Button disabled={!operateEnable} style={opButtonStyle} type="primary" size="small"
                    ghost onClick={() => setModalVisible(true)}>{i18next.t("user:Delete User")}</Button>
                </div>
            }
            {
              Setting.isAdminOrganization(nodeData?.uid) ? null :
                <Row align="bottom" style={{color: "#333"}}>{i18next.t("user:Show Direct Users")}
                  <Switch
                    checked={isDirectUser}
                    onClick={handleSwitchDirectUser}
                    style={{marginLeft: "10px", marginRight: "16px"}} />
                </Row>
            }
          </Row>
        </>
      )}
      loading={loading}
      onChange={handleTableChange}
    />
    <Col span={24} style={{background: "#fff"}}>
      <UserImport
        visible={importVisible}
        dismiss={() => {setImportVisible(false);}}
        nodeData={nodeData}
        type={importType} />
    </Col>
    <Col span={24}>
      <UserTransfer visible={tranferModalVisible}
        dismiss={() => setTranferModalVisible(false)}
        confirmLoading={userTransferConfirmLoading}
        onConfirmSelect={(transferedNodes) => {
          onTransferUser(transferedNodes);
        }}
      />
    </Col>
    <Modal
      title={i18next.t("user:Delete User")}
      visible={modalVisible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      confirmLoading={confirmLoading}
      onOk={handleDeleteUsers}
      onCancel={() => {setModalVisible(false);}}
    >
      <p>{i18next.t("user:Sure to delete user")}?</p>
    </Modal>
    <Modal
      title={i18next.t("user:Forbidden Account")}
      visible={forbiddenModalVisible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      confirmLoading={confirmLoading}
      onOk={handleForbiddenUser}
      onCancel={() => {setForbiddenModalVisible(false);}}
    >
      <div style={{marginLeft: "30px"}}>
        <p>{i18next.t("user:Sure to forbbiden this account")}?</p>
        <p>1.{i18next.t("user:Forbidden Account Description1")}</p>
        <p>2.{i18next.t("user:Forbidden Account Description2")}</p>
        <p>3.{i18next.t("user:Forbidden Account Description3")}</p>
      </div>
    </Modal>
    <UserExportModal visible={userExportModalVisible}
      dismiss={() => setUserExportModalVisible(false)}
      confirmLoading={userExportConfirmLoading}
      organId={nodeData?.uid}
      isOrgSelectDisabled={true}
      onConfirmSelect={(exportAll, direct, transferedNodes) => {
        if (exportAll) {
          UserBackend.exportUsers(nodeData.uid, {});
        } else {
          const params = {
            deptId: transferedNodes.map(item => item.uid),
            isDirectly: direct,
          };
          UserBackend.exportUsers("", params);
        }
      }}
    />
  </div>;
};

export default UserListTable;
